/** @module harbinger/eventProcessor/harbingerService */

export { default as postEvent } from './postEvent'
export { default as constants } from './constants'
